module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw exclude-auto-rw page-open-right-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block11"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "dateline-rw",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "dateline1"
    }
  }, [_c('em', [_vm._v("Billings, Montana—1997")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p47"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("H")]), _vm._v("e’s trouble.”\n         ")]), _c('p', {
    attrs: {
      "id": "p48"
    }
  }, [_vm._v("Twelve-year-old Griff Warren sat hunched in the principal’s office, his split lip swollen and bloody, scowling as his mother and Principal Marcone discussed his latest run-in with a classmate.")]), _c('p', {
    attrs: {
      "id": "p49"
    }
  }, [_vm._v("“Griff gave Jeremy Thornton a bloody nose and a black eye.” The principal’s voice frosted over. “Jeremy’s parents will be sending you the medical bills, Ms. Warren.”")]), _c('p', {
    attrs: {
      "id": "p50"
    }
  }, [_vm._v("Griff’s mother held tightly to her handbag as she turned to her son. “Why did you do it?”")]), _c('p', {
    attrs: {
      "id": "p51"
    }
  }, [_vm._v("“He called me a name.”")]), _c('p', {
    attrs: {
      "id": "p52"
    }
  }, [_vm._v("“What name?”")]), _c('p', {
    attrs: {
      "id": "p53"
    }
  }, [_vm._v("The boy shook his head, unwilling to say "), _c('i', [_vm._v("bastard")]), _vm._v(" in front of his mother. It always hurt her more than him.\n         ")]), _c('p', {
    attrs: {
      "id": "p54"
    }
  }, [_vm._v("She turned to the principal. “Perhaps we could speak more openly if my son could leave your office.”")]), _c('p', {
    attrs: {
      "id": "p55"
    }
  }, [_vm._v("The principal nodded. “Griff. Go to the gym. Maybe you can work off some of that aggression while I speak with your mother.”")]), _c('p', {
    attrs: {
      "id": "p56"
    }
  }, [_vm._v("Griff rose awkwardly to his feet.")]), _c('p', {
    attrs: {
      "id": "p57"
    }
  }, [_vm._v("As he crossed to the door, he heard his mother say, in a voice barely above a whisper, “Griff is a good boy.”")]), _c('p', {
    attrs: {
      "id": "p58"
    }
  }, [_vm._v("“Good boys don’t react with violence whenever someone angers them.” The principal waited a beat before adding, “I really think you ought to consider military school next year, Ms. Warren. Your son needs more discipline than we can offer him.”")]), _c('p', {
    attrs: {
      "id": "p59"
    }
  }, [_vm._v("“Griff is all I have…” His mother turned. Seeing him still in the doorway she frowned. “Go on now, Griff.”")]), _c('p', {
    attrs: {
      "id": "p60"
    }
  }, [_vm._v("He stalked to the gym and tossed aside his backpack before picking up a basketball and hurling it toward the hoop. It dropped cleanly through the net, and he raced up to catch it. In one reflexive movement he hurled it all the way across the floor toward the opposite hoop, where it circled the rim before dropping through the net.")]), _c('p', {
    attrs: {
      "id": "p61"
    }
  }, [_vm._v("A deep voice from the locker room startled him. “Pretty impressive. Think you can do that again?”")]), _c('p', {
    attrs: {
      "id": "p62"
    }
  }, [_vm._v("He turned and glared at Mr. Wood, the new coach hired at midseason when old Mr. Harris was forced to take a sick leave. “What do you care?”")]), _c('p', {
    attrs: {
      "id": "p63"
    }
  }, [_vm._v("The young coach shrugged. “Since you didn’t try out for the team, I guess you’re not interested in basketball. But I just figured, with all that anger, it might be interesting to see if you can repeat that performance.”")]), _c('p', {
    attrs: {
      "id": "p64"
    }
  }, [_vm._v("“Who says I’m angry?”")]), _c('p', {
    attrs: {
      "id": "p65"
    }
  }, [_vm._v("“Aren’t you?”")]), _c('p', {
    attrs: {
      "id": "p66"
    }
  }, [_vm._v("Griff tossed the ball as hard as he could, and had the satisfaction of seeing it drop through the net. Working up a full head of steam, he raced to retrieve it before tossing it to the opposite net where, once again, it circled and dropped.")]), _c('p', {
    attrs: {
      "id": "p67"
    }
  }, [_vm._v("When he retrieved the ball yet again, the young coach walked up beside him. “A dollar says you can’t do a repeat of that.”")]), _c('p', {
    attrs: {
      "id": "p68"
    }
  }, [_vm._v("“Make it five bucks.”")]), _c('p', {
    attrs: {
      "id": "p69"
    }
  }, [_vm._v("The coach shook his head. “Two.”")]), _c('p', {
    attrs: {
      "id": "p70"
    }
  }, [_vm._v("Griff heaved the ball and turned away, not even bothering to watch as it swished through the net. With a frown he held out his hand and Mr. Wood dropped two bills in it.")]), _c('p', {
    attrs: {
      "id": "p71"
    }
  }, [_vm._v("“Can you do it anytime? Or only when you’re mad?”")]), _c('p', {
    attrs: {
      "id": "p72"
    }
  }, [_vm._v("Griff shrugged. “I don’t know.”")]), _c('p', {
    attrs: {
      "id": "p73"
    }
  }, [_vm._v("“What’s that supposed to mean?”")]), _c('p', {
    attrs: {
      "id": "p74"
    }
  }, [_vm._v("The boy picked up the ball. “I only play when I’m mad.”")]), _c('p', {
    attrs: {
      "id": "p75"
    }
  }, [_vm._v("“I see. Tell you what.” The young coach gave him a long, assessing look. “You come back tomorrow after school and play with the team.”")]), _c('p', {
    attrs: {
      "id": "p76"
    }
  }, [_vm._v("“Why should I?”")]), _c('p', {
    attrs: {
      "id": "p77"
    }
  }, [_vm._v("“I could say because it’s a great stress reliever.” The coach grinned. “The truth? Jeremy Thornton wants to be captain. That honor goes to the best player on the team. You know what I’ve learned?” His voice lowered. “A good, old-fashioned fight may be good for the soul, but there are better ways to exact revenge.”")]), _c('p', {
    attrs: {
      "id": "p78"
    }
  }, [_vm._v("Startled, Griff looked up and saw the glint of unspoken humor in the coach’s eyes.")]), _c('p', {
    attrs: {
      "id": "p79"
    }
  }, [_vm._v("Seeing his mother waiting in the hall, he dropped the ball and picked up his backpack.")]), _c('p', {
    attrs: {
      "id": "p80"
    }
  }, [_vm._v("As he started away Mr. Wood said, “I heard what Jeremy called you, son. That’s some shiner you gave him. Just remember—there are other ways of winning without resorting to your fists. Sometimes, success can be the sweetest revenge of all.”")]), _c('p', {
    attrs: {
      "id": "p81"
    }
  }, [_vm._v("Something in the quiet way the man spoke to him had Griff’s mind working overtime as he followed his mother to the car. He had a whole lot to think about.")]), _c('p', {
    attrs: {
      "id": "p82"
    }
  }, [_vm._v("Maybe there "), _c('i', [_vm._v("was")]), _vm._v(" a better way. Maybe he’d even think about military school for next year. For now, he’d just decided to give basketball a try. Not because he loved the game. But Jeremy did, and he expected to be captain.\n         ")]), _c('p', {
    attrs: {
      "id": "p83"
    }
  }, [_vm._v("For the first time in hours Griff smiled.")]), _c('p', {
    attrs: {
      "id": "p84"
    }
  }, [_vm._v("It caused his lip to start bleeding again.")]), _c('p', {
    attrs: {
      "id": "p85"
    }
  }, [_vm._v("He never even noticed the pain.")]), _c('div', {
    staticClass: "leading-line-rw",
    attrs: {
      "id": "leading-line5"
    }
  }, [_c('p', {
    attrs: {
      "id": "p86"
    }
  })]), _c('p', {
    staticClass: "dateline-rw",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "dateline21"
    }
  }, [_c('em', [_vm._v("The Hills of Afghanistan—Winter")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p87"
    }
  }, [_vm._v("Thirty-year-old Capt. Griff Warren tucked the envelope into his back pocket and filled a foam cup with coffee. Spotting a vacant corner of Tango Company Compound, he ambled over, juggling his rifle in one hand, coffee in the other. For Griff, now in his third tour of serving with the marines in Afghanistan, it was second nature to grab these quiet moments when he could, knowing that at any time the stillness of the night could be shattered by a blast of incoming fire.")]), _c('p', {
    attrs: {
      "id": "p88"
    }
  }, [_vm._v("Dropping into the dirt, he settled his back against the low stone wall and tore open the envelope bearing the name and address of a Montana law firm. After a long drink of steaming coffee, he unfolded a letter from his mother, which, according to the date, would have been written shortly before her death. Her musings, handwritten and often several pages long, were always filled with news of the fickle weather in Montana, drought, range fires, and occasionally the misbehavior of local politicians. Seeing the date at the top of the page, tears sprang to his eyes, and he felt a band tighten around his heart as he realized this would have been her last letter to him. He blinked, expecting more of the same sort of mundane news.")]), _c('p', {
    attrs: {
      "id": "p89"
    }
  }, [_vm._v("His attention sharpened as he began to read her stunning words.")]), _c('div', {
    staticClass: "block-rw",
    attrs: {
      "id": "letter1"
    }
  }, [_c('p', {
    staticClass: "salute-rw",
    attrs: {
      "id": "salute1"
    }
  }, [_c('em', [_vm._v("My dearest Griff,")])]), _c('p', {
    staticClass: "l-rw",
    attrs: {
      "id": "p90"
    }
  }, [_c('em', [_vm._v("Please understand that this is the hardest thing I’ve ever had to write. I know that you gave up asking about your father when you were no more than five or six, after learning that your questions would send me into fits of tears. I saw the way you backed off, keeping your questions to yourself, rather than hurt me. I knew that my silence was driving a wedge between us, but I simply could never bring myself to speak of the man I’d foolishly loved and lost. Now, however, since my doctor has told me to get my affairs in order, my only affair of any importance, my only concern, is you, Griff. You deserve to know the truth.")])]), _c('p', {
    staticClass: "l-rw",
    attrs: {
      "id": "p91"
    }
  }, [_c('em', [_vm._v("When I was very young, and enjoying my first teaching assignment in a tiny Montana town called Copper Creek, I met a handsome young rancher who took my breath away. For several weeks we enjoyed a torrid romance, which I foolishly assumed would last a lifetime. Within weeks I heard that his former fiancée had returned from a modeling assignment in the South Seas and had agreed to give up her career to become his wife. Shortly after that, I learned I was expecting a baby. Instead of confronting him with what I knew would be unwelcome news at such a time in his life, I chose to remain silent. Instead of renewing my teaching contract, I quietly moved to Billings and made a life for myself and you. Over the years I had many opportunities to marry, but somehow, after that one blazing romance, the prospect of a life with anyone else seemed dull and bland. I decided that my wonderful son and the many students whose lives were touched briefly by me would have to be enough to fill my life.")])]), _c('p', {
    staticClass: "l-rw",
    attrs: {
      "id": "p92"
    }
  }, [_c('em', [_vm._v("Though it shamed me to contact your father after all these years, my first duty must be to you. Therefore, my darling Griff, I have sent him the necessary documents to prove the legality of my claim. If you are reading this letter, it means that he and his lawyers are convinced that you are, indeed, his son and heir, and they have included my letter to you in their formal documents as I requested.")])]), _c('p', {
    staticClass: "l-rw",
    attrs: {
      "id": "p93"
    }
  }, [_c('em', [_vm._v("Please accept my heartfelt apology for withholding such vital information from you for a lifetime. I have always loved you, Griff. And now, with death at my doorstep, my greatest hope is that you will forgive me and understand that I was doing what I thought best for both of us.")])]), _c('p', {
    staticClass: "signature-rw",
    attrs: {
      "id": "signature1"
    }
  }, [_c('em', [_vm._v("Your loving mother")])])]), _c('p', {
    staticClass: "text-indent-rw",
    attrs: {
      "id": "p94"
    }
  }, [_vm._v("Shocked to his core, Griff unfolded a second lengthy document, signed, witnessed, and duly registered with the state of Montana, declaring him the legal son and heir of Murdoch “Bear” MacKenzie.")]), _c('p', {
    attrs: {
      "id": "p95"
    }
  }, [_vm._v("At long last his father had a name. After a lifetime of questions and doubts. After a lifetime of searching the faces of strangers, wondering if the man passing him on the street could be the one. At long last, Griff had his answer:")]), _c('p', {
    attrs: {
      "id": "p96"
    }
  }, [_vm._v("Murdoch MacKenzie.")]), _c('p', {
    attrs: {
      "id": "p97"
    }
  }, [_vm._v("The name meant nothing to him. The truth meant everything to him. There really was a man out there somewhere who had learned of a son he’d never met. But he would, by God. As soon as this tour was up, Murdoch MacKenzie would meet the result of a careless, reckless love affair of thirty years ago.")]), _c('p', {
    attrs: {
      "id": "p98"
    }
  }, [_vm._v("Griff’s hand fisted. And then he would do what he’d wanted to do for all these endless, painful years. His blood ran hot with the thought of a knock-down, drag-out bloody fight ending with MacKenzie flat on his back and regretting the day he’d walked away from Melinda Warren without a second thought.")]), _c('p', {
    attrs: {
      "id": "p99"
    }
  }, [_vm._v("Melinda. The thought of his very private, stoic mother had Griff going still. How she must have suffered for her foolishness. And how she must have loved this man, to walk away with her secret intact rather than intrude on his life.")]), _c('p', {
    attrs: {
      "id": "p100"
    }
  }, [_vm._v("Griff had never questioned her love for him. But he’d spent an entire childhood wondering about the man who had fathered him. Had he abandoned her because she was pregnant? Had she been the one to flee rather than spend the rest of her life with someone she deemed unworthy?")]), _c('p', {
    attrs: {
      "id": "p101"
    }
  }, [_vm._v("Now Griff knew otherwise. Though this letter gave a name, there were still too many gaps in his information. How had Murdoch MacKenzie received this sudden, shocking news? Was he angry? Dismissive?")]), _c('p', {
    attrs: {
      "id": "p102"
    }
  }, [_vm._v("The fact that his lawyer had forwarded Melinda’s last letter, along with legal documents declaring him the son of Murdoch MacKenzie, proved that the man was at least trying to do the honorable thing.")]), _c('p', {
    attrs: {
      "id": "p103"
    }
  }, [_vm._v("Everything else remained a mystery.")]), _c('p', {
    attrs: {
      "id": "p104"
    }
  }, [_vm._v("But, Griff vowed, he would have his answers.")]), _c('p', {
    attrs: {
      "id": "p105"
    }
  }, [_vm._v("After a lifetime, he deserved the truth. All of it, no matter who was hurt by the questions.")]), _c('p', {
    attrs: {
      "id": "p106"
    }
  }, [_vm._v("“Hey, Captain.”")]), _c('p', {
    attrs: {
      "id": "p107"
    }
  }, [_vm._v("The shout from his buddy Jimmy Gable had him looking over with a blank stare.")]), _c('p', {
    attrs: {
      "id": "p108"
    }
  }, [_vm._v("“I said, you just got mail, Captain. Me, too.”")]), _c('p', {
    attrs: {
      "id": "p109"
    }
  }, [_vm._v("“Yeah.” Griff tucked the letter in his pocket and got to his feet, his mind awhirl with so many jumbled thoughts, he could barely speak.")]), _c('p', {
    attrs: {
      "id": "p110"
    }
  }, [_vm._v("He’d been home to bury his mother less than a month ago. And now this letter was proof of just what had occupied her mind as she lay dying. Instead of worrying about herself, she’d been more concerned with connecting him with his father. A man he’d never known. A name he’d never heard until now.")]), _c('p', {
    attrs: {
      "id": "p111"
    }
  }, [_vm._v("Serving in this godforsaken outpost, he’d already learned how crazy life could be. Now he’d just been given proof that life as he knew it had gone completely mad.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7378ff7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s004-Chapter-001.vue
// module id = 69
// module chunks = 0